export const WIDGET_GET_DEVICES_READINGS = 'widget-get-devices-readings';
export const WIDGET_GET_DEVICES_READINGS_RESULT = `${WIDGET_GET_DEVICES_READINGS}/result`;
export const WIDGET_GET_DEVICES_READINGS_ERROR = `${WIDGET_GET_DEVICES_READINGS}/error`;
